import { useLanguage } from '../language-context.js';
import content from '../content.js';

const BlockContent = () => {
  const { lang } = useLanguage();
  const t = content[lang].contents;

  return (
    <div className="contents">
      <h3 className="contents-title">{t.title}</h3>
      <p className="contents-intro">{t.intro}</p>
      <div className="contents-grid">
        <div className="contents-group">
          <h4>{t.articlesLabel}</h4>
          <ul>
            {t.articles.map((item) => (
              <li key={item.href}><a href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a></li>
            ))}
          </ul>
        </div>
        <div className="contents-group">
          <h4>{t.talksLabel}</h4>
          <ul>
            {t.talks.map((item) => (
              <li key={item.href}><a href={item.href} target="_blank" rel="noopener noreferrer">{item.label}</a></li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default BlockContent;
